import React from 'react';
import '../../../assets/css/style.css';
import '../../../assets/css/bootstrap.css';

const SecondInfo = () => {
    return (
        <div className="container">

            <div className="row-1">
                <img src="assets/img/logo-mark.png" alt="Universe" width="50px" height="auto"/>
                <h3>Welcome to Univrs</h3>
                <h5>Where finding college romance is a step easier</h5>
            </div>

            <div className="row-2">
                <h2>Don't be shy to make the first move</h2>
            </div>

            <div className="row-3">
                <div className="intro-wrapper">
                    <p className="intro-body">
                        If you like someone, leave them a note on their profile or pick something on their profile to like.
                    </p>
                </div>

                <button type="submit" className="uni-btn">Got it!</button>
            </div>

            <div className="row-4">

                <button className="nav-button">
                    <i className="btn-icon fa fa-address-book" aria-hidden="true"></i>
                    <span className="btn-txt">Name</span>
                </button>

                <button className="nav-button">
                    <i className="btn-icon fa fa-birthday-cake" aria-hidden="true"></i>
                    <span className="btn-txt">Age</span>
                </button>

                <button className="nav-button">
                    <i className="btn-icon fa fa-venus-mars" aria-hidden="true"></i>
                    <span className="btn-txt">Gender</span>
                </button>

                <button className="nav-button" active>
                    <i className="btn-icon fa fa-university" aria-hidden="true"></i>
                    <span className="btn-txt">Campus</span>
                </button>

                <button className="nav-button">
                    <i className="btn-icon fa fa-picture-o" aria-hidden="true"></i>
                    <span className="btn-txt">Pictures</span>
                </button>

                <button className="nav-button">
                    <i className="btn-icon fa fa-heart" aria-hidden="true"></i>
                    <span className="btn-txt">Interests</span>
                </button>

            </div>

        </div>
    )
}

export default SecondInfo;